import { FLASH_MESSAGE_ADD } from "./flashMessageConstants";

export const addFlashMessage = (message) => ({
    type: FLASH_MESSAGE_ADD,
    payload: message,
});
